<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-900">
    <div class="bg-gray-800 p-8 rounded-lg shadow-lg w-full max-w-md">
      <!-- Contenedor para centrar el logo -->
      <div class="flex justify-center mb-6">
        <img src="/logo.png" class="w-6/12" alt="Logo" />
      </div>
      <form @submit.prevent="login">
        <div class="mb-4">
          <label class="block text-gray-400 mb-2" for="username"
            >Correo Electrónico</label
          >
          <input
            v-model="username"
            type="text"
            id="username"
            class="w-full p-2 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-blue-500"
            required
          />
        </div>
        <div class="mb-6">
          <label class="block text-gray-400 mb-2" for="password"
            >Contraseña</label
          >
          <input
            v-model="password"
            type="password"
            id="password"
            class="w-full p-2 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-blue-500"
            required
          />
        </div>
        <button
          type="submit"
          class="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition duration-200"
        >
          Iniciar Sesión
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import AuthStateHelper from "../helpers/authStateHelper";
import AuthProvider from "@/helpers/providers/AuthProvider";

export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  methods: {
    async login() {
      try {
        const credentials = btoa(`${this.username}:${this.password}`);

        const response = await AuthProvider.login(credentials);
        const userData = response.data;
        const { accessToken, refreshToken, ...rest } = userData;
        console.log(rest);
        AuthStateHelper.setAuth({ accessToken, refreshToken });
        this.$router.push("/");
      } catch (error) {
        if (error.response) {
          console.error("Error:", error.response.data.message);
          alert(`Error: ${error.response.data.message}`);
        } else {
          console.error("Error al conectar con el servidor:", error.message);
          alert("Ocurrió un error al intentar iniciar sesión.");
        }
      }
    },
  },
};
</script>